export default __webpack_public_path__ + "static/media/logo.ebfdd157.svg";